export default __webpack_public_path__ + "static/media/arrowLeft.3b17eb9d.svg";